import React, { useEffect, useRef, useState } from "react";
import * as pdfjsLib from "pdfjs-dist/build/pdf";

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

function dataUrlToUint8Array(dataUrl) {
  const base64 = dataUrl.split(",")[1] || "";
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}
const ViewPdf = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(0);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const wrapperRef = useRef(null);

  const pdfCanvasRefs = useRef([]);
  const pdfDocRef = useRef(null);

  useEffect(() => {
    if (!fileUrl) return;
    const loadPdf = async () => {
      try {
        pdfCanvasRefs.current = []; // reset
        setNumPages(0);
        const pdfData = dataUrlToUint8Array(fileUrl);
        const loadingTask = pdfjsLib.getDocument({ data: pdfData });
        const pdf = await loadingTask.promise;

        pdfDocRef.current = pdf;
        setNumPages(pdf.numPages); // sẽ trigger effect renderAllPages
      } catch (err) {
        console.error("Load PDF error:", err);
        setLoadingPdf(false);
      }
    };

    loadPdf();
  }, [fileUrl]);

  useEffect(() => {
    const renderAllPages = async () => {
      const pdf = pdfDocRef.current;
      if (!pdf || numPages === 0) return;

      try {
        for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
          const page = await pdf.getPage(pageNumber);

          const rotation = page.rotate || 0;
          const viewport = page.getViewport({
            scale: 1.2,
            rotation: -rotation, // đưa về 0 độ hiển thị
          });

          const canvas = pdfCanvasRefs.current[pageNumber - 1];
          if (!canvas) continue;

          const ctx = canvas.getContext("2d");
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({
            canvasContext: ctx,
            viewport,
          }).promise;
        }

        // sau khi render xong hết -> đặt vị trí mặc định (nếu user chưa click)
      } catch (err) {
        console.error("Render pages error:", err);
      } finally {
        setLoadingPdf(false);
      }
    };

    renderAllPages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numPages]);
  return (
    <div className="content-view-pdf">
      {fileUrl && (
        <div ref={wrapperRef}>
          {/* TẤT CẢ CÁC TRANG PDF */}
          {Array.from({ length: numPages }).map((_, index) => (
            <canvas
              key={index}
              ref={(el) => (pdfCanvasRefs.current[index] = el)}
              style={{
                width: "100%",
                display: "block",
                marginBottom: 8,
              }}
            />
          ))}

          {/* Ô ký – mặc định ở trang cuối bên phải, click đâu nhảy tới đó */}

          {loadingPdf && (
            <div
              style={{
                position: "absolute",
                top: 8,
                left: 8,
                padding: "4px 8px",
                background: "rgba(0,0,0,0.5)",
                color: "#fff",
                borderRadius: 4,
              }}
            >
              Đang tải PDF...
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ViewPdf;
